import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../config";

const url = `${API_BASE_URL}`;

let sessionExpiredHandled = false;

function isTokenExpired(error) {
  if (!error?.response) return false;
  const status = error.response.status;
  const msg = (
    error.response?.data?.data?.message ||
    error.response?.data?.message ||
    ""
  ).toLowerCase();
  return (
    status === 401 ||
    status === 403 ||
    (status === 400 && msg.includes("invalid token"))
  );
}

function logoutAndGoToLogin() {
  let loginPath = "/login";
  try {
    const vuex = JSON.parse(localStorage.getItem("vuex") || "{}");
    // Admin console staff (admin, sales, signups) sign back in through the admin login
    if (["admin", "sales", "signups"].includes(vuex?.user?.user?.type)) loginPath = "/admin/login";
    if (vuex.user) {
      vuex.user = { user: {}, loading: false, token: null };
      localStorage.setItem("vuex", JSON.stringify(vuex));
    }
  } catch (e) { /* ignore */ }
  localStorage.removeItem("token");
  localStorage.removeItem("headers");
  window.location.href = loginPath;
}

function handleSessionExpired() {
  if (sessionExpiredHandled) return;
  sessionExpiredHandled = true;

  Swal.fire({
    title: "Session expired",
    html: "<p style='margin:8px 0 0;color:#081735;font-weight:600'>Please sign in again to continue.</p>",
    icon: "info",
    confirmButtonText: "Sign in",
    confirmButtonColor: "#2563cc",
    allowOutsideClick: false,
  }).then(logoutAndGoToLogin);
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isTokenExpired(error) && localStorage.getItem("token")) {
      handleSessionExpired();
      return Promise.reject(error);
    }

    if (error?.response) {
      const errorMessage =
        error.response?.data?.data?.message ||
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: "Error!",
        text: "Network error. Please check your connection.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    return Promise.reject(error);
  }
);

const getMakers = async () => {
  try {
    let localToken = localStorage.getItem("token");
    const token = { headers: { authtoken: `${localToken}` } };
    return await axios.get(`${url}/product/getCompanies`, token);
  } catch (error) {
    throw error;
    console.error(error);
    // throw {
    //     code: error.response.status || 417,
    //     message: error.response.data.data.message || 'something went wrong please try again'
    // };
  }
};
const getCars = async (id) => {
  try {
    let localToken = localStorage.getItem("token");
    const token = { headers: { authtoken: `${localToken}` } };
    return await axios.get(`${url}/product/getCarsByCompanyId/${id}`, token);
  } catch (error) {
    console.error(error);
    // throw {
    //     code: error.response.status || 417,
    //     message: error.response.data.data.message || 'something went wrong please try again'
    // };
  }
};

const getAllCars = async () => {
  try {
    let localToken = localStorage.getItem("token");
    const token = { headers: { authtoken: `${localToken}` } };
    return await axios.get(`${url}/product/allCars`, token);
  } catch (error) {
    console.error(error);
    throw {
      code: error.response?.status || 417,
      message:
        error.response?.data?.data?.message ||
        "something went wrong please try again",
    };
  }
};

const submitBid = async (data) => {
  try {
    let localToken = localStorage.getItem("token");
    const token = { headers: { authtoken: `${localToken}` } };
    let res = await axios.post(`${url}/bid/submit-bid`, data, token);
    if (res) {
      Swal.fire(
        "Your offer is submitted!",
        "Please check back in 24–48 hours for the best offers.",
        "success"
      ).then(() => {
        // Redirect to offers page after popup is closed
        window.location.href = "/offers";
      });
    }
  } catch (error) {
    // Error is handled by axios interceptor
    console.error(error);
  }
};

export default {
  getMakers,
  getCars,
  getAllCars,
  submitBid,
};
